export default {
  name: "Barcode",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 28H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2zM4 6v20h24V6H4zm4 3H6v14h2V9zm8 0h-2v14h2V9zm3 0h-2v14h2V9zm1.5 0h-1v14h1V9zM13 9H9v14h4V9zm13 0h-4v14h4V9z",
  },
}
